// extracted by mini-css-extract-plugin
module.exports = {"itemsList":"styles_itemsList__oQwge","isDraggingOver":"styles_isDraggingOver__q_D0g"};